import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"
import { EstablishmentLeadData } from '../types/establishmentLead.type'
import { AxiosResponse } from 'axios'

interface UseCreateEstablishmentLeadContractFeeProps {
  establishmentLeadId?: string
  onSuccess?: (response: AxiosResponse<{ data: EstablishmentLeadData }>) => void
  onError?: () => void
}

export const useCreateEstablishmentLeadContractFee = ({ establishmentLeadId, onSuccess, onError }: UseCreateEstablishmentLeadContractFeeProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['createEstablishmentLeadContractFee'],
    mutationFn: (data: { label: string, value: string }) => {
      const lead = {
        contract_attributes: {
          contract_fees_attributes: [
            {
              fee_template_id: data.value,
            }
          ]
        }
      }

      return privateAxios.put(`/funnel/establishment/leads/${establishmentLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}
